import { jsxs as L, Fragment as t, jsx as r } from "react/jsx-runtime";
const e = () => /* @__PURE__ */ L(t, { children: [
  /* @__PURE__ */ r(
    "path",
    {
      d: "M17 17H15.441L5.741 6.327C5.552 6.119 5.283 6 5.001 6H2V8H4.559L8.649 12.5L4.559 17.001H2V19.001H5.001C5.283 19.001 5.552 18.882 5.741 18.674L10 13.987L14.259 18.673C14.448 18.881 14.717 19 14.999 19H17V22L22 18L17 14V17Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ r(
    "path",
    {
      d: "M15.4411 8H17.0001V11L22.0001 7.062L17.0001 3V6H14.9991C14.7171 6 14.4481 6.119 14.2591 6.327L10.8911 10.034L12.3711 11.38L15.4411 8Z",
      fill: "currentColor"
    }
  )
] });
export {
  e as default
};
